"use client";

import { createContext, useContext } from "react";
import type { ToastProps } from "../..";

export interface ToastContextValue {
	notify: (toast: ToastProps) => void;
	remove: (identifier: ToastProps["identifier"]) => void;
}

export const NotificationContext = createContext<ToastContextValue>({} as ToastContextValue);

export function useNotifications() {
	const context = useContext(NotificationContext);

	if (context === null) throw new Error("Notification context is not available");

	return context;
}
